import React from 'react'
import Slidesec1 from './SliderSec1/SliderSec1'
import SliderSec2 from './SliderSec2/SliderSec2'



function SliderAbout() {
  return (
  <>
    <Slidesec1 />
    <SliderSec2 />
  </> 
  )
}

export default SliderAbout
